import { USER_ROLES } from '@features/auth/utils/constants.ts';
import { UserCountryCode } from '@shared/types/countryCodes.ts';
import { RoleDetails } from '@shared/types/role.ts';

interface FindCurrentUserRoleDataParams {
  rolesDetails: RoleDetails[] | undefined;
  userRoleId: string;
  isExternalDirectClient: boolean;
  isExternalAgency: boolean;
}

export function findCurrentUserRoleData({
  rolesDetails,
  userRoleId,
  isExternalDirectClient,
  isExternalAgency,
}: FindCurrentUserRoleDataParams): RoleDetails | undefined {
  return rolesDetails?.find((roleDetails) => {
    if (isExternalDirectClient) {
      return roleDetails.name === USER_ROLES.EXTERNAL_DIRECT_CLIENT;
    }

    if (isExternalAgency) {
      return roleDetails.name === USER_ROLES.EXTERNAL_AGENCY;
    }

    return roleDetails.roleGroups.some((roleGroup) => roleGroup.id === userRoleId);
  });
}

export function findInternalUserCountryCode(roleDetails: RoleDetails, userRoleId: string): UserCountryCode | null {
  return roleDetails.roleGroups.find((roleGroup) => roleGroup.id === userRoleId)?.country ?? null;
}
